// extracted by mini-css-extract-plugin
export default {"breadcrumbList":"Breadcrumb_breadcrumbList__B-dw7","breadcrumbListItem":"Breadcrumb_breadcrumbListItem__6Z26O"};